import { getNostoFilters, getSorting } from '@srcDS/components/organisms/categoryProductList/utils/filterHelper';

interface Stream {
  offset?: number;
  count?: number;
  projectSpecificData?: {
    merchandised_category?: string | null;
  };
  query?: any;
}

interface Products {
  from: number;
  size: number;
  sort: any[];
  filter: any[];
  categoryPath?: string | null;
}

interface SearchRequest {
  query?: string;
  products: Products;
}

export const buildSearchRequest = (
  searchPhrase: string | undefined,
  stream: Stream = {},
  isCuratedForYou: boolean = false,
): SearchRequest => {
  const { offset: from = 0, count: size = 25, projectSpecificData, query } = stream;

  const products: Products = {
    from,
    size,
    sort: getSorting(query),
    filter: getNostoFilters(query),
  };

  const searchRequest: SearchRequest = isCuratedForYou
    ? { products }
    : {
      query: searchPhrase || 'category',
      products,
    };

  if (!searchPhrase) {
    searchRequest.products = {
      ...searchRequest.products,
      categoryPath: projectSpecificData?.merchandised_category ?? null,
    };
  }

  return searchRequest;
};